module.exports = __webpack_public_path__ + "static/img/3.4f8f439.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/3.png
// module id = b2/0
// module chunks = 0